// extracted by mini-css-extract-plugin
export default {"wrap":"consultationUserSubordination_wrap__QG0-a"};